import React from "react";

const VerticalMenu = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M14.889 30.8c0-1.767 1.393-3.2 3.111-3.2 1.718 0 3.111 1.433 3.111 3.2 0 1.767-1.393 3.2-3.111 3.2-1.718 0-3.111-1.433-3.111-3.2zM14.889 18c0-1.767 1.393-3.2 3.111-3.2 1.718 0 3.111 1.433 3.111 3.2 0 1.767-1.393 3.2-3.111 3.2-1.718 0-3.111-1.433-3.111-3.2zM14.889 5.2C14.889 3.433 16.282 2 18 2c1.718 0 3.111 1.433 3.111 3.2 0 1.767-1.393 3.2-3.111 3.2-1.718 0-3.111-1.433-3.111-3.2z"
            fill={fill}
        />
    </svg>
);

export default VerticalMenu;
